export const ROUTES = {
  Trail: 'trail',
  Drilldown: 'drilldown',
};
